
import {timeout} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


import { AppSettingsService } from './app-settings-service';
import { AuthService } from './auth-service';
import { AovComparisonInitialResult } from './aov-comparison-initial-result';
import { AovComparisonResult } from './aov-comparison-result';

@Injectable()
export class AovCalculationService {
    constructor(private _auth: AuthService, private _http: HttpClient, private _settingsService: AppSettingsService) {
    }

    private get options() {
        const options = {
            headers: new HttpHeaders({ Authorization: this._auth.authorizationHeader })
        };
        return options;
    }

    public initPremiums(data: any, callback: (value: AovComparisonInitialResult) => void, error?: (error:any) => void) {
        let options = this.options;
        this._http.post<AovComparisonInitialResult>(`${this._settingsService.settings.mpApiBaseUrl}/AovComparison/Calculations`, data, options).pipe(
            timeout(3 * 60 * 1000))
            .subscribe(data => {
                callback(data);
            }, error);
    }

    public getPremiums(key: string, callback: (value: AovComparisonResult) => void, error?: (error: any) => void) {
        this._http.get<AovComparisonResult>(`${this._settingsService.settings.mpApiBaseUrl}/AovComparison/Calculations/${key}`, this.options).subscribe(data => {
            callback(data);
        }, error);
    }

    public sendLead(afd: any, callback: (value: boolean) => void, error?: (error: any) => void) {
        let options = this.options;
        this._http.post<boolean>(`${this._settingsService.settings.mpApiBaseUrl}/AovComparison/Leads`, afd, options).pipe(
            timeout(3 * 60 * 1000))
            .subscribe(data => {
                callback(data);
            }, error);
    }
}
